import { Injectable } from '@angular/core';
import {MatDialog} from '@angular/material/dialog';
import {MatSnackBar} from '@angular/material/snack-bar';
import { Observable } from 'rxjs'; 

import { PopupmessageTypes } from './popup-types';
import {ConfirmDialogComponent} from './popupmessage.component';

@Injectable()
export class PopupService{
    constructor(public dialog: MatDialog, public _snackbar:MatSnackBar) {}
    currentDialog:any = null;

    /**
        Title,
        Message,
        Subtitle DefaultValue:"",
        Notification level DefaultValue:1 (1 = info, 2 = warning, 3 = error)
     */
    public confirm(title:string, message:string, subtitle:string="",notificationLevel:number=1, confirmButtonTitle?:string, dismissButtonTitle?:string):Observable<boolean>{
        const dialogRef = this.dialog.open(ConfirmDialogComponent, {
            maxWidth:"500px",
            maxHeight:"100vh",
            panelClass:"reponsiveLayout",
            data: {
                type: PopupmessageTypes.confirm,
                title: title,
                subtitle:subtitle,
                message:message,
                items:[],
                notificationLevel:notificationLevel,
                clickRequired:true,
                confirmButtonTitle:typeof confirmButtonTitle === "undefined" ? "Yes" : confirmButtonTitle.substring(0,20),
                dismissButtonTitle:typeof dismissButtonTitle === "undefined" ? "No" : dismissButtonTitle.substring(0,20)
            }
        });
        this.currentDialog = dialogRef;
        return new Observable<any>(observer =>{
            dialogRef.afterClosed().subscribe(dialogResult => {
                observer.next(dialogResult);
            });
        })
    }

    public ok(title:string, message:string, subtitle:string="",notificationLevel:number=1,clickRequired:boolean=false, items:string[]=[]):Observable<boolean>{
        const dialogRef = this.dialog.open(ConfirmDialogComponent, {
            maxWidth:"500px",
            maxHeight:"100vh",
            panelClass:"reponsiveLayout",
            data: {
                type: PopupmessageTypes.ok,
                title: title,
                subtitle:subtitle,
                message:message,
                items:items,
                notificationLevel:notificationLevel,
                clickRequired:clickRequired
            }
        });
        this.currentDialog = dialogRef;
        return new Observable<any>(observer =>{
            dialogRef.afterClosed().subscribe(dialogResult => {
                observer.next(dialogResult);
            });
        })
    }

    public Loading(title:string, message:string, maxDurationSec:number=0,notificationLevel:number=1):Observable<boolean>{
        const dialogRef = this.dialog.open(ConfirmDialogComponent, {
            maxWidth:"500px",
            maxHeight:"100vh",
            panelClass:"reponsiveLayout",
            data: {
                type: PopupmessageTypes.loading,
                title: title,
                subtitle:"",
                message:message,
                items:[],
                notificationLevel:notificationLevel,
                clickRequired:true,
                maxDurationSec:maxDurationSec
            }
        });
        this.currentDialog = dialogRef;
        return new Observable<any>(observer =>{
            dialogRef.afterClosed().subscribe(dialogResult => {
                observer.next(dialogResult);
            });
        })
    }

    public close(){
        this.currentDialog.close();
    }

}